import { AnalyticsEventName, VisitedFromActionSource, reportUsage } from '@ms/yammer-data/dist/telemetry';
import { useTranslations } from '@ms/yammer-i18n-react';
import NavigationStrings from '@ms/yammer-strings/dist/Navigation';
import { leadershipCornerPageUrl } from '@ms/yammer-web-support/dist/urls';
import { useCallback, useMemo } from 'react';

import { usePageUrlClick } from '../../../navigation/SubHeader/hooks/usePageUrlClick';
import { VivaEngageNavigationHeaderPivotItem } from '../types';

type UseLeadershipCornerPivotItem = () => VivaEngageNavigationHeaderPivotItem;
export const useLeadershipCornerPivotItem: UseLeadershipCornerPivotItem = () => {
  const t = useTranslations(NavigationStrings);
  const onPageUrlClick = usePageUrlClick();
  const reportAndRedirectToLeadershipCornerPage = useCallback(() => {
    reportUsage({
      eventName: AnalyticsEventName.LeadershipCornerTabClicked,
      eventProperties: {
        from: VisitedFromActionSource.VivaEngageNavigationHeader,
      },
    });
    onPageUrlClick(leadershipCornerPageUrl);
  }, [onPageUrlClick]);

  return useMemo(
    () => ({
      key: leadershipCornerPageUrl,
      supportedRoutes: ['/leadership-corner'],
      onClick: reportAndRedirectToLeadershipCornerPage,
      text: t.appNavigationLeadershipCorner(),
    }),
    [reportAndRedirectToLeadershipCornerPage, t]
  );
};
